import { render, staticRenderFns } from "./hotel.vue?vue&type=template&id=27d93a81&scoped=true&"
import script from "./hotel.vue?vue&type=script&lang=ts&"
export * from "./hotel.vue?vue&type=script&lang=ts&"
import style0 from "./hotel.vue?vue&type=style&index=0&id=27d93a81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d93a81",
  null
  
)

export default component.exports